const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CompleteAndConfirmCommand: any = {
    AddRequestData: Backofficebff + '/v1/completeandconfirmrequest/add',
    UpdateRequestData: Backofficebff + '/v1/completeandconfirmrequest/update',
    DeleteRequestData: Backofficebff + '/v1/completeandconfirmrequest/delete',
};
